export default __webpack_public_path__ + "static/media/40,000.f6d0c78e.png";